import StyledTrigger from "./styles/TriggerStyles"
import StyledIcon from "./styles/IconStyles"
import { useDropdown } from "./Root"
import { CSSFn } from "../styles"

type TriggerProps = Readonly<{
  children: string
  disabled?: boolean
  css?: CSSFn
}>

export const Trigger = ({ children, disabled = false, css }: TriggerProps) => {
  const { state, dispatch } = useDropdown(`Trigger`)

  return (
    <StyledTrigger
      css={css}
      aria-haspopup="menu"
      disabled={disabled}
      title={disabled ? `disabled` : undefined}
      onClick={() => {
        if (!disabled) {
          state.open ? dispatch({ type: `close` }) : dispatch({ type: `open` })
        }
      }}
    >
      {children}
      <StyledIcon />
    </StyledTrigger>
  )
}
